import * as React from "react";
import { useId } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgQuestion = (props) => {
	const __svgrId = useId();
	return /* @__PURE__ */ _jsx("svg", {
		viewBox: "0 0 20 20",
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg",
		...props,
		children: /* @__PURE__ */ _jsx("path", {
			d: "M7.77063 7.69863C7.95872 7.16397 8.32995 6.71312 8.8186 6.42594C9.30724 6.13876 9.88175 6.03378 10.4404 6.1296C10.999 6.22542 11.5057 6.51585 11.8707 6.94946C12.2357 7.38306 12.4355 7.93185 12.4346 8.49863C12.4346 10.0986 10.0346 10.8986 10.0346 10.8986M10.0986 14.0986H10.1066M18.0986 10.0986C18.0986 14.5169 14.5169 18.0986 10.0986 18.0986C5.68035 18.0986 2.09863 14.5169 2.09863 10.0986C2.09863 5.68035 5.68035 2.09863 10.0986 2.09863C14.5169 2.09863 18.0986 5.68035 18.0986 10.0986Z",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	});
};
export default SvgQuestion;
